<template>
  <div class="subsector electronics">
    <div class="parent-sector">
      <p>Industrial Processes</p>
    </div>
    <div class="content">
      <div class="row">
        <div class="col-md-6">
          <h1>Electronics</h1>
          <div class="row">
            <div class="col-sm">
              <p>
                Electronics consists of emissions from the manufacturing of
                semiconductors, flat panel displays (FPDs), and photovoltaics
                (PV). During the manufacture of these electronics, F-GHGs,
                including HFCs, PFCs, SF₆, and NF₃, are emitted from two
                repeated activities: (1) cleaning of chemical vapor deposition
                chambers and (2) plasma etching (etching intricate patterns into
                successive layers of films and metals).
              </p>
              <p>
                Between 1990 and 2015, emissions from electronics manufacturing
                increased by 519%. From 2015 through 2030, emissions from FPD
                manufacturing are estimated to triple. This projection assumes
                large growth in the FPD industry, tapering from an assumed
                annual growth rate of about 9% from 2015 through 2025 to about
                4% from 2025 through 2050. From 2015 through 2030, emissions
                from semiconductor manufacturing are estimated to increase by
                46% primarily because of the increased demand for electronic
                goods. Projected emissions from the solar PV industry decrease
                by 72% from 2015 through 2030. Abatement potential in the
                electronics source category is estimated to be 51 MtCO₂e, 56% of
                the baseline emissions. Implementing abatement measures in the
                electronics source category is costly.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <p class="center">
            <button
              @click="
                switchComponent('ChartElectronics1');
                activate(1);
              "
              :class="{ active: active_el == 1 }"
            >Projected Emissions</button>
            <button
              @click="
                switchComponent('ChartElectronics2');
                activate(2);
              "
              :class="{ active: active_el == 2 }"
            >Reduction Potential</button>
          </p>

          <div class="container">
            <component v-bind:is="currentComp"></component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChartElectronics1 from "@/components/industrialprocesses/ChartElectronics1";
import ChartElectronics2 from "@/components/industrialprocesses/ChartElectronics2";

export default {
  components: {
    ChartElectronics1,
    ChartElectronics2
  },
  data() {
    return {
      currentComp: "ChartElectronics1",
      active_el: 1
    };
  },
  methods: {
    switchComponent(comp) {
      //alert("test comp: " + comp);
      return (this.currentComp = comp);
    },
    activate: function(el) {
      this.active_el = el;
    }
  }
};
</script>

<style scoped>
h1 {
  font-weight: normal;
  font-size: 1.6rem;
  margin-bottom: 1rem;
}
.subsector {
  background: url("../../assets/bg-lightblue-bar.png") 0 0 repeat-x;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  border-radius: 5px;
}
.content {
  padding-top: 30px;
  padding-left: 50px;
  padding-right: 50px;
  position: absolute;
  top: 50px;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: scroll;
  overflow-x: hidden;
  min-height: 0;
}
.keypoints {
  border-left-style: solid;
  border-left-width: 5px;
  border-left-color: #b8da66;
  margin-left: 2rem;
}
.keypoints h3 {
  text-transform: uppercase;
  text-align: left;
  font-size: 1rem;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
  color: #333;
  margin-left: 1rem;
  margin-bottom: 1rem;
}
.keypoints ul {
  margin-left: 1.5rem;
}
.keypoints li {
  display: list-item;
  list-style-type: disc;
  margin-bottom: 0.8rem;
}
img {
  float: right;
  margin-top: 50px;
}
button {
  background-color: #0071bc;
  border-radius: 3px;
  border: 0;
  color: #fff;
  font-size: 1rem;
  padding: 0.25rem 0.5rem;
  margin-top: 2rem;
  cursor: pointer;
  margin-left: 1rem;
}
.parent-sector {
  position: static;
  color: #012e51;
  z-index: 1;
  font-weight: bold;
  font-size: 1.2rem;
  padding-top: 10px;
  margin-left: 50px;
}

.center button {
  position: static !important;
}
</style>
